<template>
  <div>
    <v-btn
            text outlined
            @click.stop="dialog = true"
            class="centered-element"
    >
      Что это такое? 🤔
    </v-btn>
    <v-dialog
            v-model="dialog"
            max-width="550"
            scrollable
    >
      <v-card style="height: 300px;">
        <v-card-title class="headline">Что это за визуализация?</v-card-title>
        <v-card-text>
          <div>
            Это репрезентация базы знаний в виде графа, которая содержится
            <a
                    target="_blank" rel="noopener noreferrer"
                    href="https://github.com/roadmap-project/dev-learning-guidelines/tree/master/database/"
            >
              здесь
            </a>
          </div>
          <br>
          <div>
            Визуализация показывает как связаны между собой учебные планы для подготовки и знания/инструменты/мягкие навыки
          </div>
          <br>
          <div>
            Как это работает?
            <ul>
              <li>Отметь интересующие учебные планы (roadmaps)</li>
              <li>Отметь знания, инструменты или "мягкие" навыки</li>
              <li>Тыкай на интересующие вершинки и изучай 🚀</li>
            </ul>
          </div>
          <br>
          <div>
            Подсказки:
            <ul>
              <li>Если ткнуть на понятие в дереве, то в графе оно подсветится</li>
              <li>Если выбрать дорожные карты, то отобразятся только связанные понятия</li>
              <li>Если нет выбранных дорожных карт, то будут показаны все выбранные понятия</li>
              <li>Над деревом есть поиск 🙃</li>
            </ul>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
                  text
                  @click="dialog = false"
          >
            Я все понял!
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    name: "HelpVisDialog",
    data() {
      return {
        dialog: false
      }
    }
  }
</script>

<style scoped>
  .centered-element {
    width: 200px;
    height: 100px;
    position: absolute;
    top: 0%;
    right: 0%;
    margin-right: 50px;
    margin-top: 50px;
  }
</style>
